<script>
	const _ = require('underscore');

	module.exports = {
		props: ['new-assignment-form', 'select-all-students', 'student-selection-error'],
		data() {
			return {
				newAssignmentFormInternal: null
			};
		},
		watch: {
			newAssignmentForm: {
				handler(value) {
					this.newAssignmentFormInternal = value;
				},
				immediate: true
			},
			newAssignmentFormInternal(value) {
				if (!_.isEqual(value, this.data)) {
					this.$emit('update:newAssignmentForm', value);
				}
			}
		}
	};
</script>
<template>
	<div>
		<div class="label">
			Choose students for assignment:
			<ul class="help list-inline">
				<li><a v-on:click="selectAllStudents(true)">Select All</a></li>
				<li><a v-on:click="selectAllStudents(false)">Deselect All</a></li>
			</ul>
		</div>
		<div
			class="form-row"
			v-if="studentSelectionError">
			<div class="validation-error">
				{{ studentSelectionError }}
			</div>
		</div>
		<div class="form-row-input">
			<template v-for="studentSelection in newAssignmentFormInternal.studentSelections">
				<auto-form-row
					part-of-row
					v-bind:data.sync="studentSelection.selected"
					v-bind:form-property="'student-' + studentSelection.uid"
					v-bind:label="studentSelection.text"
					type="checkbox">
				</auto-form-row>
			</template>
		</div>
	</div>
</template>
